import * as PropTypes from 'prop-types';
import Tag from 'antd/lib/tag';
import { Link } from 'react-router-dom';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { useFela } from 'react-fela';

import config from 'config/index';
import { utils as uploaderUtils } from 'modules/uploader';

import DeleteNews from '../../containers/DeleteNews';

import rule from './News.rule';

const { buildSource } = uploaderUtils;

const ImagePropTypes = {
    uri: PropTypes.string,
    id: PropTypes.string,
};

const NewsPropTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    time: PropTypes.object.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string),
    images: PropTypes.arrayOf(PropTypes.shape(ImagePropTypes)),
    delayed: PropTypes.bool.isRequired,
};

export const NewsShape = PropTypes.shape(NewsPropTypes);

const getNewsLink = (id, delayed) =>
    config.routes[delayed ? 'newsDelayedDetail' : 'newsDetail'].replace(':id', id.toString());

const News = ({ id, title, time, body, tags, images, delayed }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <div>
                <h3>
                    <Link to={getNewsLink(id, delayed)}>{title}</Link>
                    <DeleteNews id={id} delayed={delayed} />
                </h3>
                <div className="news-tags">
                    <Tag color="blue">
                        <FormattedDate
                            value={time.toDate()}
                            year="numeric"
                            month="long"
                            day="2-digit"
                            hour="numeric"
                            minute="numeric"
                        />
                    </Tag>
                    {delayed ? (
                        <Tag color="red">
                            <FormattedMessage id="news.delayed" />
                        </Tag>
                    ) : (
                        <Tag color="green">
                            <FormattedMessage id="news.sent" />
                        </Tag>
                    )}
                </div>
                <p>
                    {images && images[0] && (
                        <img
                            alt={body}
                            className="news-image"
                            width="150"
                            src={buildSource(images[0].id, { width: 300, height: 300 })}
                        />
                    )}
                    {body}
                </p>
                <div className="news-tags">
                    {tags.map(tag => (
                        <Tag key={tag.toString()}>{tag}</Tag>
                    ))}
                </div>
            </div>
        </div>
    );
};

News.propTypes = NewsPropTypes;
News.defaultProps = {
    body: null,
    tags: [],
    images: [],
};

export default News;
